import { PortalType } from '../domain/portal';

function getPortalType(): PortalType {
  const envPortalType = import.meta.env.VITE_PORTAL_TYPE;
  if (envPortalType) {
    return envPortalType as PortalType;
  }

  if (window.location.hostname.indexOf('verify') >= 0) {
    return 'verify';
  } else {
    return 'apply';
  }
}

export { getPortalType };
